export interface IGeoPoint {
	longitude: number;
	latitude: number;
}